import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-x-0 bottom-0 h-1/2 bg-gray-100" }, null, -1)
const _hoisted_3 = { class: "max-w-7xl mx-auto sm:px-6 lg:px-8" }
const _hoisted_4 = { class: "relative shadow-xl sm:rounded-2xl sm:overflow-hidden" }
const _hoisted_5 = { class: "absolute inset-0" }
const _hoisted_6 = { class: "relative px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-8" }
const _hoisted_7 = { class: "text-center font-['Poly'] text-4xl tracking-tight sm:text-5xl lg:text-6xl transition ease-in-out" }
const _hoisted_8 = { class: "block text-white" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mt-10 max-w-sm mx-auto sm:max-w-none sm:flex sm:justify-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "space-y-4 sm:space-y-0 sm:mx-auto sm:inline-grid sm:grid-cols-2 sm:gap-5" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "/topotobago",
      class: "flex items-center justify-center px-4 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-teal-700 bg-white hover:bg-teal-50 sm:px-8"
    }, " Explore Top O' Tobago "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "/book",
      class: "flex items-center justify-center px-4 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-teal-500 bg-opacity-60 hover:bg-opacity-70 sm:px-8"
    }, " Find availability ")
  ])
], -1)
const _hoisted_10 = { class: "bg-gray-100" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-center text-sm font-semibold uppercase text-gray-500 tracking-wide" }, " Certificates of Excellence from Trip Advisor (2013-2020), AirBnb Super Host and Tripexpert "),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-6 grid grid-cols-5 gap-2 sm:grid-cols-2 md:grid-cols-5 lg:grid-cols-5" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 flex justify-center" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "h-32",
        src: "https://res.cloudinary.com/millsit/image/upload/v1648401840/TOT/awards/tripexpert_award_gdseyn.png",
        alt: "Tripexpert 2023 Expert Choice Award"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 flex justify-center" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "h-32",
        src: "https://res.cloudinary.com/millsit/image/upload/v1648401840/TOT/awards/TripAdvisor-2020-Travelers-Choice-Award_qt8mjo.png",
        alt: "TripAdvisor 2020 Travelers Choice Award"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 flex justify-center" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "h-32",
        src: "https://res.cloudinary.com/millsit/image/upload/v1648401840/TOT/awards/trip_advisor_award_2019_viwrqd.png",
        alt: "Mirage"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 flex justify-center" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "h-32",
        src: "https://res.cloudinary.com/millsit/image/upload/v1648402725/TOT/awards/airbnb_superhost_idsylu.png",
        alt: "AirBnb Super host"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 flex justify-center" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "h-32",
        src: "https://res.cloudinary.com/millsit/image/upload/c_scale,w_200/v1648401905/TOT/awards/safetravels_mi4n84.png",
        alt: "Trinidad & Tobago Safe Travels"
      })
    ])
  ])
], -1)
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "flex justify-center items-center pb-10 mx-auto" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" 4.7 stars on "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "underline",
    href: "https://maps.app.goo.gl/CqojeEK7yEHEpjaU9",
    target: "_blank"
  }, "Google Reviews")
], -1)

import ImageCarousel from "@/components/ImageCarousel.vue";
import ReviewsHome from "@/components/ReviewsHome.vue";
import FiveStars from "@/components/FiveStars.vue";
import BlogListCards from "@/components/BlogListCards.vue";
import { onUnmounted, ref, nextTick } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const logoUrl = "https://res.cloudinary.com/millsit/image/upload/v1648245957/TOT/logo_tot_v4.1_vn7cxw.png";

const posts = [
  {
    title: "Welcome!",
    href: "#",
    description:
      "Top O Tobago occupies the entire crest of a hill close to the Caribbean Sea coast of SW Tobago. It takes 7 minutes to walk to Arnos Vale Beach, a great snorkeling beach. There is a 360 degree view of the surrounding hills, valleys and coastline.",
    imageUrl: "https://res.cloudinary.com/millsit/image/upload/v1648403672/TOT/beach_290x190_h6pnfn.jpg",
  },
  {
    title: "High Class Accommodation",
    href: "#",
    description:
      "The villa is comprised of a main house and 3 studio apartments or cabanas. Each cabana has its own patio and garden, and access to a common swimming pool. Top O'Tobago offers the best of both hotel and apartment living. There is a resident host to attend to your needs while on the property and to help you plan your holiday; and the house and each apartment are fully equipped for all your self catering needs.",
    imageUrl: "https://res.cloudinary.com/millsit/image/upload/v1648403672/TOT/pool_patio_290x190_gcjqsw.jpg",
  },
  {
    title: "Relaxing Vacation",
    href: "#",
    description:
      "The villa is located on six acres of land with flower gardens, fruit trees, jungle vegetation and walking paths; and also within a 10 to 20 minute drive of numerous beaches, hiking trails, restaurants and shopping facilities. Top O Tobago is truly at the nexus of many worlds.",
    imageUrl: "https://res.cloudinary.com/millsit/image/upload/v1648403672/TOT/romance_290x190_b2cexw.jpg",
  },
];

let heroTextArr = ["The Perfect Holiday", "Villa living with flexibility"];
let heroTextId = ref(0);
let intervalThing = setInterval(async function () {
  if (heroTextId.value >= heroTextArr.length - 1) heroTextId.value = 0;
  else heroTextId.value++;
  await nextTick();
}, 3000);

onUnmounted(() => {
  // let count = 0;
  // intervalThing.cancel()
  clearInterval(intervalThing);
});

return (_ctx: any,_cache: any) => {
  const _component_DefaultLayout = _resolveComponent("DefaultLayout")!

  return (_openBlock(), _createBlock(_component_DefaultLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("main", null, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(ImageCarousel)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h1", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(heroTextArr)[_unref(heroTextId)]), 1)
                  ]),
                  _hoisted_9
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(FiveStars),
                _hoisted_14
              ])
            ])
          ])
        ]),
        _createVNode(BlogListCards, { posts: posts }),
        _createVNode(ReviewsHome)
      ])
    ]),
    _: 1
  }))
}
}

})